import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://ae03277e84ba4ca6bd93bdcd17f47823@sentry.cloudez.io/25",

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});